var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#1B2B41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6803 27.8516V27.4297C23.6803 26.8203 23.774 26.3203 23.9615 25.9297C24.149 25.5339 24.498 25.1172 25.0084 24.6797C25.7167 24.0807 26.162 23.6302 26.3443 23.3281C26.5318 23.026 26.6256 22.6615 26.6256 22.2344C26.6256 21.7031 26.4537 21.2943 26.11 21.0078C25.7714 20.7161 25.2818 20.5703 24.6412 20.5703C24.2297 20.5703 23.8287 20.6198 23.4381 20.7188C23.0475 20.8125 22.5995 20.987 22.0943 21.2422L21.6334 20.1875C22.6178 19.6719 23.6464 19.4141 24.7193 19.4141C25.7141 19.4141 26.4876 19.6589 27.0396 20.1484C27.5917 20.638 27.8678 21.3281 27.8678 22.2188C27.8678 22.599 27.8157 22.9349 27.7115 23.2266C27.6126 23.513 27.4641 23.7865 27.2662 24.0469C27.0683 24.3021 26.6412 24.7161 25.985 25.2891C25.4589 25.737 25.11 26.1094 24.9381 26.4062C24.7714 26.7031 24.6881 27.099 24.6881 27.5938V27.8516H23.6803ZM23.2975 30.1719C23.2975 29.4635 23.61 29.1094 24.235 29.1094C24.537 29.1094 24.7688 29.2005 24.9303 29.3828C25.0969 29.5651 25.1803 29.8281 25.1803 30.1719C25.1803 30.5052 25.0969 30.7656 24.9303 30.9531C24.7636 31.1354 24.5318 31.2266 24.235 31.2266C23.9641 31.2266 23.7402 31.1458 23.5631 30.9844C23.386 30.8177 23.2975 30.5469 23.2975 30.1719Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#76808D",
    strokeOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkDark);
export default __webpack_public_path__ + "static/media/question-mark-dark.35e8b24a16ddc7dcbb4844474879adac.svg";
export { ForwardRef as ReactComponent };